<template>
  <nav class="view-controls">
    <div class="view-controls__wrapper" v-show="showProgress">
      <span class="view-controls__group">
        <button class="view-controls__button" v-show="!showMap" v-on:click="openMap">View Map</button>
        <button class="view-controls__button" v-show="showMap" v-on:click="hideMap">Hide Map</button>
      </span>
      <ul class="view-controls__list">
        <li class="view-controls__item" v-for="(item, index) in routes">
          <view-link :to="{ name: item.name, params: { scene: index + 1 }}" v-bind:scene="item.scene" v-bind:current="sceneID">{{ item.name }}</view-link>
        </li>
      </ul>
      <span class="view-controls__group">
        <button class="view-controls__button" v-show="showBack" v-on:click="goBack">Back</button>
        <button class="view-controls__button" v-show="showNext" v-on:click="goNext">Next</button>
        <button class="view-controls__button" v-show="showFinish" v-on:click="goFinish">Complete</button>
      </span>
    </div>

    <aside class="view-controls__map" v-show="showMap">
      <div class="view-controls__map-frame">

        <view-map></view-map>

      </div>
    </aside>
  </nav>
</template>

<script>
  import routes from '../routes'
  import ViewLink from '../components/ViewLink.vue'
  import ViewMap from '../components/ViewMap.vue'
  import { Scores } from '../classes/Scores'

  const scores = new Scores()

  export default {
    name: 'progress-bar',
    data () {
      return {
        routing: null,
        routes: [],
        routeCur: null,
        sceneID: 0,
        sceneCur: null,
        scenePrv: null,
        sceneNex: null,
        showBack: false,
        showNext: true,
        showFinish: false,
        showMap: false,
        showProgress: true
      }
    },
    methods: {
      load: function () {
        this.getScenes()
        this.setScene()
      },
      setMap: function () {
        let scenes = document.querySelectorAll('[id^="scene_"]')
        for (let i = 0; i < scenes.length; i++) {
          let scene = scenes[i]

          let name = scene.getAttribute('id')
          name = name.replace('scene_', '')

          let score = scores.sections[name]

          if (score && score.progress === score.total) {
            scene.classList.add('complete')
          } else {
            scene.classList.remove('complete')
          }

          scene.addEventListener('click', function (event) {
            let name = event.currentTarget.getAttribute('id')
            name = name.replace('scene_', '')
            window.app.vue.$router.push({name: name})
          })
        }
      },
      getScenes: function () {
        let paths = []
        // only return scene pages
        for (let i = 0; i < routes.length; i++) {
          if (routes[i].type === 'scene') {
            paths.push(routes[i])
          }
        }
        this.routes = paths
      },
      setScene: function () {
        let item = null
        let last = null
        let next = null
        this.sceneID = 0
        this.scenePrv = last
        this.sceneNex = next
        this.routeCur = this.$router.currentRoute
        for (let i = 0; i < this.routes.length; i++) {
          if (i > 0 && item !== null) { last = item }
          item = this.routes[i]
          if (this.routeCur && this.routeCur.name === item.name) {
            this.sceneCur = item
            this.scenePrv = last
            this.sceneID = item.scene
            next = this.routes[i + 1]
            if (next !== undefined) {
              this.sceneNex = next
            }
          }
        }

        this.showProgress = true
        if (this.routeCur.name === 'start') {
          this.showProgress = false
        }

        if (this.routeCur.name === 'conclusion') {
          this.showProgress = false
        }

        this.showFinish = false
        let lastScene = (this.routes.length - 1)
        if (this.routeCur.name === this.routes[lastScene].name) {
          // if (scores.total === scores.progress) {
          this.showFinish = true
          // }
        }

        this.showBack = this.scenePrv !== null
        this.showNext = this.sceneNex !== null
      },
      goBack: function () {
        if (this.scenePrv !== null) {
          this.$router.push({ name: this.scenePrv.name })
        }
      },
      goNext: function () {
        if (this.sceneNex !== null) {
          this.$router.push({ name: this.sceneNex.name })
        }
      },
      goFinish: function () {
        if (scores.total === scores.progress) {
          this.$router.push({ name: 'conclusion' })
        } else {
          alert('You have not answered all of the questions')
        }
      },
      openMap: function () {
        this.setMap()
        this.showMap = true
      },
      hideMap: function () {
        this.showMap = false
      }
    },
    mounted: function () {
      this.load()
    },
    components: {
      ViewLink,
      ViewMap
    }
  }
</script>



// WEBPACK FOOTER //
// ProgressBar.vue?5921f239